export enum Permission {
  COMPANY_ADMIN = "company.admin",
  SYSTEM_ADMIN = "system.admin",
  ASSETS = "assets",
  ANALYTICS = "analytics",
  ADMIN_ALARM_SETTINGS_VIEW = "admin.alarmsettings.view",
  ADMIN_ALARM_SETTINGS_EDIT = "admin.alarmsettings.edit",
}

export enum VALIDITY_TYPE {
  CONTINUOUS = "continuous",
  FIXED = "fixed",
}

export enum PERMISSION_TYPE {
  API_KEY = 1,
}

export enum USER_LANGUAGE {
  en = "English",
  fi = "Finnish",
  sv = "Swedish",
}

export enum AUDIT_LOG_KEYS {
  firstName = "first name",
  lastName = "last name",
  email = "email",
  role = "role",
  roles = "roles",
  groups = "groups",
  active = "active",
  license = "license",
  apiKey = "API key",
  description = "description",
  permissionId = "permissionId",
  user = "user",
  contact = "contact",
  users = "users",
  permissions = "permissions",
  name = "name",
  userGroup = "user group",
  deviceRights = "device rights",
  language = "language",
  timezone = "timezone",
  activeHours = "active hours",
  alarmGroupNames = "alarm groups",
  customHeaderText = "header text",
  showLocation = "Show location",
  showDate = "Show date",
  showAlarmState = "Show alarm state",
  showDescription = "Show description",
}

export enum ADMIN_USERS_TYPE {
  SYSTEM_ADMIN = 2,
  GLOBAL_ADMIN = 4,
}

export enum ADMIN_USERS {
  SYSTEM = "system",
  GLOBAL = "global",
}

export enum USER_TYPE {
  USER,
  CONTACT,
}
